import { useMutation } from '@tanstack/react-query'
import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { AuthLayout } from '../components/AuthLayout.js'
import { Button, Field, Input } from '../components/ui.js'
import { useTRPC } from '../lib/trpc.js'

export function ForgotPassword() {
  const trpc = useTRPC()
  const [email, setEmail] = useState('')

  const request = useMutation(trpc.auth.requestPasswordReset.mutationOptions())

  const submit = (event: FormEvent) => {
    event.preventDefault()
    request.mutate({ email })
  }

  // The same confirmation whether or not the address exists. Telling someone
  // "no account with that email" turns this form into a list of who works
  // here, and the server behaves the same way.
  if (request.isSuccess) {
    return (
      <AuthLayout title="Check your email">
        <div className="flex flex-col gap-4 text-sm text-ink-600">
          <p>
            If <span className="font-medium text-ink-900">{email}</span> has an account, a link to
            set a new password is on its way. It expires in an hour.
          </p>
          <p>Nothing arrived? Check the spam folder, or ask someone in the office to resend it.</p>
          <Link to="/login">
            <Button size="lg" block>
              Back to sign in
            </Button>
          </Link>
        </div>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout title="Reset your password" subtitle="We'll email you a link.">
      <form onSubmit={submit} className="flex flex-col gap-4" noValidate>
        <Field label="Email" htmlFor="email" required>
          <Input
            id="email"
            type="email"
            autoComplete="username"
            inputMode="email"
            autoCapitalize="none"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </Field>

        <Button type="submit" variant="primary" size="lg" block loading={request.isPending}>
          Send the link
        </Button>

        <p className="text-center text-sm">
          <Link to="/login" className="font-medium text-brand-600 hover:text-brand-700">
            Back to sign in
          </Link>
        </p>
      </form>
    </AuthLayout>
  )
}
